/**
 * Copyright © 2026 Adnuntius AS.
 *
 * Native Angular template interpolator for simple {{param}} / {{nested.path}}
 * strings (API errors, validation messages, titles).
 */
import {Injectable} from '@angular/core';

import {interpolateTemplate} from './interpolate-template';

@Injectable({
  providedIn: 'root'
})
export class AdnInterpolateService {
  compile(text: string): (params?: any) => string {
    return interpolateTemplate(text);
  }

  interpolate(text: string, params?: any): string {
    return this.compile(text)(params);
  }
}
